import { createSelector } from 'reselect';

import { StateDictionary } from '../reducers/utils/state-manager';

import { isIntegrationGroup } from '../util/is-integration-group';

type EmployeeGroupByOrgIdDictionary = { [orgId: number]: Array<EmployeeGroup> };
type AnnouncementsByEmployeeGroupIdDictionary = {
  [employeeGroupId: number]: Array<Announcement>;
  [employeeGroupId: string]: Array<Announcement>;
};
export type EmployeeGroupState = {
  employeeGroupsByOrgId: EmployeeGroupByOrgIdDictionary;
  employeeGroupsByOrgIdStatus: StateDictionary;
  announcementsByEmployeeGroupId: AnnouncementsByEmployeeGroupIdDictionary;
  announcementsByEmployeeGroupIdStatus: StateDictionary;
};
type State = { employeeGroups: EmployeeGroupState };

const employeeGroupsByOrgIdSelector = (state: State) => state.employeeGroups.employeeGroupsByOrgId;
const employeeGroupsByOrgIdStateSelector = (state: State) =>
  state.employeeGroups.employeeGroupsByOrgIdStatus;
export const employeeGroupsForOrgIdSelector = createSelector(
  [employeeGroupsByOrgIdSelector, (_state: State, orgId: number) => orgId],
  (employeeGroupsByOrgId, orgId) => employeeGroupsByOrgId[orgId],
);
export const integrationEmployeeGroupsForOrgIdSelector = createSelector(
  [employeeGroupsByOrgIdSelector, (_state: State, orgId: number) => orgId],
  (employeeGroupsByOrgId, orgId) =>
    (employeeGroupsByOrgId[orgId] || []).filter((g) => isIntegrationGroup(g)),
);
export const employeeGroupsForOrgIdStateSelector = createSelector(
  [employeeGroupsByOrgIdStateSelector, (_state: State, orgId: number) => orgId],
  (employeeGroupsByOrgIdState, orgId) => employeeGroupsByOrgIdState[orgId],
);

const announcementsByEmployeeGroupIdSelector = (state: State) =>
  state.employeeGroups.announcementsByEmployeeGroupId;
const announcementsByEmployeeGroupIdStateSelector = (state: State) =>
  state.employeeGroups.announcementsByEmployeeGroupIdStatus;
export const announcementsSelector = createSelector(
  [announcementsByEmployeeGroupIdSelector],
  (announcementsByEmployeeGroupId) => Object.values(announcementsByEmployeeGroupId).flat(),
);
export const announcementsForEmployeeGroupIdSelector = createSelector(
  [
    announcementsByEmployeeGroupIdSelector,
    (_state: State, employeeGroupId: number | string) => employeeGroupId,
  ],
  (announcementsByEmployeeGroupId, employeeGroupId) =>
    announcementsByEmployeeGroupId[employeeGroupId],
);
export const announcementsForEmployeeGroupIdStateSelector = createSelector(
  [
    announcementsByEmployeeGroupIdStateSelector,
    (_state: State, employeeGroupId: number | string) => employeeGroupId,
  ],
  (announcementsByEmployeeGroupIdState, employeeGroupId) =>
    announcementsByEmployeeGroupIdState[employeeGroupId as number],
);

const announcementsByEmployeeGroupIdStatusSelector = (state: State) =>
  state.employeeGroups.announcementsByEmployeeGroupIdStatus;
export const announcementsForEmployeeGroupIdStatusSelector = createSelector(
  [
    announcementsByEmployeeGroupIdStatusSelector,
    (_state: State, employeeGroupId: number | string) => employeeGroupId,
  ],
  (announcementsByEmployeeGroupIdStatus, employeeGroupId) =>
    announcementsByEmployeeGroupIdStatus[employeeGroupId as number],
);
